import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";
import { Home, LogOut, Loader2, Sun, Moon } from "lucide-react";
import { Link } from "react-router-dom";
import { useTheme } from "next-themes";

interface AdminHeaderProps {
  email: string;
  signOutLoading: boolean;
  onSignOut: () => void;
}

export const AdminHeader = ({ email, signOutLoading, onSignOut }: AdminHeaderProps) => {
  const { theme, setTheme } = useTheme();

  return (
    <header className="bg-gradient-to-r from-primary/5 via-card to-accent/20 border-b border-border px-6 py-5 shadow-sm">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          <Brand showIcon size="md" />
          <div className="flex items-center gap-1.5">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
              aria-label="Przełącz tryb ciemny"
            >
              {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </Button>
            <Button asChild variant="ghost" size="sm">
              <Link to="/">
                <Home className="w-4 h-4 mr-1.5" />
                <span className="hidden sm:inline">Strona główna</span>
              </Link>
            </Button>
            <Button onClick={onSignOut} disabled={signOutLoading} variant="outline" size="sm">
              {signOutLoading ? (
                <Loader2 className="w-4 h-4 animate-spin mr-1.5" />
              ) : (
                <LogOut className="w-4 h-4 mr-1.5" />
              )}
              <span className="hidden sm:inline">Wyloguj</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
